import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { WindowToken } from '@charlesschwab/as-ui-core';
import { CoreService } from '@charlesschwab/sac-ui-core';
import { Location } from '@angular/common';

@Injectable()
export class ContextService {

    constructor(private coreService: CoreService,
        private http: HttpClient,
        private location: Location,
        @Inject(WindowToken) private window: Window) {
    }

    isMonolithUrl(url: string): boolean {
        if (url.startsWith('si2')) {
            return true;
        }
        else {
            return false;
        }
    }

    getContextDetails(encodedContext: string, contextType: number | undefined = undefined, schwabClientId: string = '', firmId: string = ''): void {
        const path = '/api/ria.SacShellExperience/v1/api/context';
        var pathAndQuery = contextType && schwabClientId ? `${path}?contextType=${contextType}` : path;
        var url = `${this.bffGatewayUrl}` + pathAndQuery;
        this.http.get(url, { headers: this.getHeaders(schwabClientId, encodedContext, firmId) })
            .subscribe((response: any) => {
                this.coreService.currentContext = response.data.attributes;
                var currentUrl = new URL(decodeURIComponent(this.window.location.href));
                this.updateEncodedContextInUrl(currentUrl, this.coreService.currentContext.encodedContext as string);
                // Update the browser history, with the updated current context
                this.location.go(currentUrl.pathname, currentUrl.search);
            }, (error: any) => {
                console.error('Error retrieving context details', error);
            });
    }

    updateEncodedContextInUrl(url: URL, encodedContext: string): void {
        const context = url.searchParams.get('ec');
        encodedContext = decodeURIComponent(encodedContext);
        if (!context) {
            // Remove not well formed query params for encoded context
            const searchQuery = decodeURIComponent(url.search.substring(1));
            const params = searchQuery.split("&");
            if (params.length > 1 && this.isEncodedContext(this.processNotWellFormedQuery(params[0]))) { //?sbfjksbksbksab=&tab=webtrade
                url.search = params.slice(1).join('&');
            } else if (params.length == 1 && this.isEncodedContext(this.processNotWellFormedQuery(params[0]))) { // ?sabjdbadbajk=
                url.search = '';
            }
            //Scenario 1 and 4 and correct all not well formed Urls
        }
        encodedContext ? url.searchParams.set('ec', encodedContext as string) : url.searchParams.delete('ec');
    }

    // This is a workaround to handle not well formed query params coming from monolith
    private processNotWellFormedQuery(encodedContext: string): string {
        return encodedContext.endsWith("==") ? encodedContext.slice(0, -1) : encodedContext;
    }

    private isEncodedContext = (query: string) => {

        var base64regex = /^[a-zA-Z0-9\+/]*={0,2}$/;

        if (query.length % 4 == 0 && base64regex.test(query)) {// Valid Base 64 encoding
            const buffer = this.base64ToArrayBuffer(query);
            if (buffer != null && buffer.byteLength == 17) { // Valid length for obsfucation
                return true;
            }
        }

        return false;
    }

    private base64ToArrayBuffer(base64: string) {
        var binaryString = atob(base64);
        var bytes = new Uint8Array(binaryString.length);
        for (var i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes.buffer;
    }

    private getHeaders(schwabClientId: string = '', encodedContext: string = '', firmId: string = ''): HttpHeaders {
        var requestHeaders = new HttpHeaders({
            Accept: 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
            'Schwab-Env': this.coreService.environment
        });

        if (schwabClientId)
            requestHeaders = requestHeaders.append('Schwab-Client-Id', schwabClientId);

        if (encodedContext)
            requestHeaders = requestHeaders.append('SacEncodedContext', encodedContext);

        if (firmId)
            requestHeaders = requestHeaders.append('Schwab-Client-FirmId', firmId);

        return requestHeaders;
    }

    private get bffGatewayUrl(): string {
        return this.trimUrl(this.coreService.bffGatewayUrl);
    }

    private trimUrl(url: string): string {
        return url ? url.replace(/\/$/, '') : url;
    }

}
